<template>
  <!--企业选项表单-->
  <div class="entBox">
    <el-form ref="entform" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="企业全称" prop="name">
        <el-input v-model="form.name" style="width:400px" placeholder=""></el-input>
        <p style="font-size: 12px">*需与当地政府颁发的商业许可证书或企业注册证上的企业名称完全一致</p>
      </el-form-item>
      <!-- <el-form-item label="统一社会信用代码" prop="code"> -->
      <el-form-item label="统一社会信用代码">
        <el-input v-model="form.code" style="width:400px" placeholder=""></el-input>
        <p style="font-size: 12px;">*请输入15位营业执照注册号或18位的统一社会信用代码</p>
      </el-form-item>
      <el-form-item label="营业执照" prop="previewImg">
        <viewer :images="fileList" class="seeBigImg">
          <div v-for="(img,index) in fileList" style="position:relative" class="imglists">
            <img
              :src="img.url"
              :key="index"
            >
            <div class="delete"><i class="el-icon-delete2" @click="handleRemove(img)"></i></div>
          </div>
        </viewer>
        <el-upload class="upload-box" :action="`/api/basic/img/upload?AccessToken=${getSession()}`" :headers="headers" :file-list="fileList" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-success="handleAvatarSuccess" :on-remove="handleRemove" accept=".png,.jpg">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog v-model="previewImg" size="tiny">
          <img width="100%" :src="imageSrc" alt="">
        </el-dialog>
        <p style="font-size: 12px">*上传扫描文件,支持PNG/JPG图片格式；如果上传后无反应，请更换谷歌浏览器后再尝试  <a target="_blank" href="https://pc.qq.com/detail/1/detail_2661.html">下载谷歌浏览器</a></p>
      </el-form-item>
      <el-form-item label="行业">
        <el-cascader style="width:400px" placeholder="请参考营业执照填写" change-on-select :options="options" :props="defaultProp" v-model="selectedOption" @change="handleChange">
        </el-cascader>
      </el-form-item>
      <!-- <el-form-item label="企业法人" prop="legalPerson"> -->
      <el-form-item label="企业法人">
        <el-input v-model="form.legalPerson" style="width:200px" placeholder="姓名"></el-input>
      </el-form-item>
      <!-- <el-form-item label="联系电话" prop="phone"> -->
      <el-form-item label="联系电话">
        <el-input v-model="form.phone" style="width:200px" placeholder="手机号码"></el-input>
      </el-form-item>
      <el-form-item label="注册地址" prop="address">
        <dataTree @change='changeId' :defaultData='defaultPointerData'></dataTree>
        <el-input v-model="form.address" style="width:400px;display:block;margin-top:22px" placeholder="街道详细地址"></el-input>
      </el-form-item>
      <el-form-item label="中心坐标" prop="latitude">
        <el-button @click="showMap.state= true">地图选点</el-button>
        <span style="margin-left: 5px">东经：{{form.longitude | formatDegree}}，北纬：{{form.latitude | formatDegree}}</span>
<!--        <el-input style="width:150px" v-model.number="form.longitude" placeholder="经度"></el-input>-->
<!--        <el-input style="width:150px" v-model.number="form.latitude" placeholder="纬度"></el-input>-->
        <mapPointer :show="showMap" :source='{lat:form.latitude,lng:form.longitude}' @change="confirm"></mapPointer>
      </el-form-item>
      <!-- <el-form-item label="所属工业园区">
        <el-select v-model="zone" placeholder="无" style="width:200px" @change='changeZone'>
          <el-option :label="m.label" :value="m.value" v-for="m in zonelist" :key="m.value"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="所属区划">
        <scaleRegion ref="scaleRegiondata" @change="changeRegion" @changeIdval="changeRegionId" :isUpdata='isUpdata' :defaultObj='defaultObj'></scaleRegion>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import mapPointer from '../../view/component/MapPointer.vue'
import dataTree from '../../view/component/Datatree.vue'
import company from '../../data/basic/plan/company.js'
import scaleRegion from '../../components/region/ScaleRegion'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      inputsss: '',
      // 行业默认值
      defaultProp: {
        children: 'children',
        label: 'name',
        value: 'code'
      },
      defaultObj: {},
      // Form表单属性
      form: {
        address: '',
        // 地址 ,
        city: '',
        // 市代码,
        cityName: '',
        // 市名称,
        code: '',
        // 统一社会信用代码 ,
        count: '',
        // : 成员数量,
        county: '',
        // 县代码,
        countyName: '',
        // 区 / 县名称,
        createtime: '',
        // 创建时间,
        id: '',
        // id标识，uuid，由系统产生 ,
        imgName: '',
        // 行业
        industry: {
          id: '',
          name: '',
        },
        industryt: '',
        // 营业执照图片文件名 ,
        latitude: '',
        // 纬度,
        linkMan: '',
        // 企业法人 ,
        legalPerson: '',
        // 联系人 ,
        longitude: '',
        // 经度,
        name: '',
        // 机构名称 ,
        phone: '',
        // 电话 ,
        province: '',
        // 省代码,
        provinceName: '',
        // 省名称,
        regionType: 1,
        // 所属管辖范围,
        // 1 = 不跨区县， 2 = 跨区县不跨市， 3 = 跨区县、 市， 默认值不跨区县,
        regions: [],
        // (Array[RegionPartition], optional): 区划,
        role: 1, // 我的角色,0=管理员，1=普通用户 ,
        // : 我的角色,
        // 1 = 管理员， 2 = 普通用户,
        subType: '',
        // 子类型， 企业： 1 = 普通企业， 2 = 跨市企业； 工业园区： 1=国家级，2=省级，3=市级,4=县级； 饮用水源地： 1 = 一级保护区， 2 = 二级保护区， 3 = 三级保护区,
        type: '',
        // : 机构类型， 0 = 企业， 1 = 政府单位， 2 = 工业园区， 3 = 饮用水源地,
        // 4 = 其他专项,
        zone: null,
        // (Zone, optional): 所属工业园区
      },
      rules: {
        phone: [{
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          },
          {
            pattern: /^1\d{10}$/,
            message: '手机号格式错误',
            trigger: 'blur'
          }
        ],
        legalPerson: [{
          required: true,
          message: '请输入企业法人',
          trigger: 'blur'
        }],
        industryt: [{
          required: true,
          message: '请参考营业执照填写行业',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入街道详细地址',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '企业名称不能为空',
          trigger: 'blur'
        }],
        code: [{
            required: true,
            message: '营业执照不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^[A-Za-z0-9]{15}$|^[A-Za-z0-9]{18}$/,
            message: '营业执照格式错误',
            trigger: 'blur'
          }
        ],
        linkMan: [{
          required: true,
          message: '企业法人不能为空',
          trigger: 'blur'
        }],
        latitude: [{
          type: 'number',
          required: true,
          message: '请选择地图坐标',
          trigger: 'change'
        }],
      },
      latitude: '',
      longitude: '',
      showMap: {
        state: false
      },
      latlng: {
        lat: '',
        lng: ''
      },
      // 营业执照预览
      previewImg: false,
      // 默认预览文件
      fileList: [],
      //图片地址
      imgName: '',
      //大图预览地址
      imageSrc:'',
      zone: '',
      zonelist: [{
        value: '不属于工业园',
        label: '不属于工业园'
      }],
      defaultPointerData: [],
      // 行业
      options: [],
      selectedOptions: [],
      selectedOption: [],
      //区域检验结果
      validRegion:false,
    }
  },
  props: {
    modifyenf: {
      type: Object
    },
    isUpdata: {
      type: Boolean
    },
  },
  computed: {
    ...mapState({
      dataEntlist(state) {
        return state.dataEntlist
      }
    }),
    headers(){
      return {
      'Authorization': 'Bearer '+ sessionStorage.getItem('publicToken')
      }
    }
  },
  // 初始化数据
  created() {
    const TOKEN = sessionStorage.getItem('publicToken')
    if (this.isUpdata) {
      if (!this.dataEntlist) {
        this.$router.replace('/myunit')
      } else {
        this.form = JSON.parse(JSON.stringify(this.dataEntlist))
        if (this.form.industry !== null) {
          //一级
          if(this.form.industry.parent === -1){
            this.selectedOption = [this.form.industry.id]
          //两级
          }else{
            this.selectedOption = [this.form.industry.parent, this.form.industry.id]
          }
        }
        let imgName = this.form.imgName
        let imglist = []
        if (imgName.indexOf(';') !== -1) {
          let newName = imgName.split(';')
          for (let i = 0; i < newName.length; i++) {
            if(newName[i]){
              imglist.push({
                url: `/api/basic/img/get?name=${newName[i]}&AccessToken=${TOKEN}`,
                name: newName[i],
                response: newName[i]
              })
            }

          }
        } else {
          if(this.form.imgName){
            imglist.push({
              url: `/api/basic/img/get?name=${this.form.imgName}&AccessToken=${TOKEN}`,
              name: this.form.imgName,
              response: this.form.imgName
            })
          }

        }
        this.imgName = this.form.imgName + ';'
        this.fileList = imglist
        this.defaultPointerData = [this.form.province, this.form.city, this.form.county]
        if (this.dataEntlist.regionType === 3) {
          this.defaultObj = {
            regionType: this.dataEntlist.regionType,
            regions: this.dataEntlist.regions
          }
        } else {
          this.defaultObj = {
            city: this.dataEntlist.regions[0].city,
            county: this.dataEntlist.regions[0].county,
            regionType: this.dataEntlist.regionType
          }
        }
      }
    }
  },
  mounted() {
    this.getCountyList()
    this.getZoneList()
    this.Gettree()
  },
  methods: {
    // 数据的类型
    changeRegionId(val) {
      this.form.regionType = val
    },
    // 获取Token
    getSession() {
      return sessionStorage.getItem('publicToken')
    },
    // 获取所属区划数据
    changeRegion(data) {
      this.form.regions = data
      if (this.form.regionType === 3) {
        if (this.form.regions && this.form.regions.length > 1) {
          if (this.form.regions && this.form.regions.length >= 2 && this.form.regions[1].city.code === '') {
            this.$message.error('跨市类型必须输入2条及以上信息')
            this.validRegion = false;
            return;
          }
        } else {
          this.$message.error('跨市类型必须输入2条及以上信息')
          this.validRegion = false;
          return;
        }
      } else {
        if (this.form.regions && this.form.regions[0].city.code === '') {
          this.$message.error('单个区县类型不能为空')
          this.validRegion = false;
          return
        }
      }
      this.validRegion = true;
    },

    // 提交表单
    onSubmitenf() {
      this.$refs['scaleRegiondata'].get_datalist()
      if(this.validRegion){
        this.$refs['entform'].validate((valid) => {
          if (valid) {
            this.$emit('change', this.form)
          } else {
            return false;
          }
        });
      }
    },
    // 取消输入的
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 执行确认操作
    confirm(val) {
      this.form.latitude = Math.floor(val.lat * 1000000) / 1000000
      this.form.longitude = Math.floor(val.lng * 1000000) / 1000000
    },
    // 执行取消或者关闭
    cancel(val) {
      this.showMap.state = val
    },
    // 获取区县列表
    getCountyList() {
      (async() => {
        let statelist = await company.get_tree()
        this.pro = statelist;
        this.city = this.pro[0]['children'];
        this.county = this.city[0]['children'];
      })()
    },
    getZoneList() {
      (async() => {
        let list = await company.get_zone_list()
        let zonelist = [{
          value: '',
          label: '不属于工业园'
        }]
        for (let i = 0; i < list.length; i++) {
          zonelist.push({
            value: list[i].id,
            label: list[i].name
          })
        }
        this.zonelist = zonelist
      })()
    },
    changeZone() {
      this.form.zone = {
        id: this.zone
      }
    },
    delectImg(params) {
      (async() => {
        let getState = await company.img_delete(params)
        if (getState.status) {
          this.$message.success('图片删除成功')
        } else {
          this.$message.error(getState.msg)
        }
      })()
    },
    // 得到树
    Gettree(params) {
      (async() => {
        try {
          let tree = await company.industry_tree(params)
          this.selectedOptions = tree
          for (let i = 0; i < tree[0].children.length; i++) {
            for (let j = 0; j < tree[0].children[i].children.length; j++) {
              if (tree[0].children[i].children[j].children.length == 0) {
                delete tree[0].children[i].children[j].children
              }
            }
          }
          this.options = tree[0].children
        } catch (error) {
          this.$message.error('网络错误，请稍候重试')
        }
      })()
    },
    // 上传成功返回
    handleAvatarSuccess(res, file) {
      if (!res) return
      this.imgName += res + ';'
      if (this.imgName.indexOf(';') == 0) {
        this.imgName = this.imgName.substring(1)
      }
      let imgNameCopy = JSON.parse(JSON.stringify(this.imgName))
      this.form.imgName = imgNameCopy.substring(0, this.imgName.length - 1)
      this.fileList.push(file)
    },
    // 删除图片上传
    handleRemove(file, fileList) {
      let imgNameCopy = JSON.parse(JSON.stringify(this.imgName))
      let currImgListCopy = imgNameCopy.split(';'),
        currImgList = [],
        currImgName = null
      for (let i = 0; i < currImgListCopy.length; i++) {
        if (currImgListCopy[i]) {
          currImgList.push(currImgListCopy[i])
        }
      }
      let currImg = []
      for (let i = 0; i < currImgList.length; i++) {
        if (file.response === currImgList[i] || file.name === currImgList[i]) {
          currImgName = file.response || file.name
          currImgList.splice(i, 1)
          this.fileList.splice(i,1)
        }
      }
      this.form.imgName = currImgList.join(';')
      this.imgName = currImgList.join(';') + ';'

      //由于文件删除导致之前备案中营业执照不可见，故不物理删除
      // this.delectImg({
      //   fileName: currImgName
      // })
      this.$message.success('图片删除成功')
    },
    // 图片预览大图
    handlePictureCardPreview(file) {
      this.imageSrc = file.url;
      this.previewImg = true;
    },
    // 监听注册地址变化
    regionChange() {

    },
    // Name
    changeId(val) {
      let obj={
        city: val[1],
        county: val[2],
        regionType: 1
      }
      this.$refs.scaleRegiondata.setValueData(obj)
      if (val.length === 2) {
        this.form.county = ''
        this.form.city = val[1]
        this.form.province = val[0]
      } else {
        this.form.county = val[2]
        this.form.city = val[1]
        this.form.province = val[0]
      }
    },
    // 行业
    handleChange(val) {
      this.form.industryt = val[0]
      if (val.length == 1) {
        this.form.industry={
          id: val[0],
          name: '',
        }
      } else if (val.length == 2) {
        this.form.industry={
          id: val[1],
          name: '',
        }
      }
    },
  },
  components: {
    mapPointer,
    dataTree,
    scaleRegion
  }
}

</script>
<style lang="stylus" scoped>
.otherBox {
  clear: both;
}

.entBox {
  padding-bottom: 20px;
}



</style>



// WEBPACK FOOTER //
// Entform.vue?301dd62b